var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/_user-agent.js
// module id = 87
// module chunks = 0